import { useEffect, useState } from 'react';
import { Routes, Route, HashRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Home from './pages/home';
import About from './pages/about';
import Contact from './pages/contact';
import Footer from './components/footer';
import Companies from './pages/companies';
import Career from './pages/career';
import Menu from './components/menu';
import CookiesPopup from './components/cookiesPopup';
import ScrollToTop from './components/scrollToTop';
import CookiePolicy from './pages/cookiePolicy';
import KvkPolicy from './pages/kvkPolicy';
import GTMPageView from './components/gtmPageView';
import NotFound from './pages/notFound';
import OfflineNotice from './components/offlineNotice';
import './styles/global.scss';

const App = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => {
      setReady(true);
    }, 1500);

    return () => clearTimeout(t);
  }, []);

  if (!ready) {
    return (
      <div className="load-spinner">
        <span className="loader"></span>
      </div>
    );
  }

  const openMobileMenu = () => {
    document.body.classList.add('menu-open');
    setIsMenuOpen(true);
  };

  const closeMobileMenu = () => {
    document.body.classList.remove('menu-open');
    setIsMenuOpen(false);
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <OfflineNotice />
      <GTMPageView />
      <ScrollToTop />
      <Menu isOpen={isMenuOpen} onClose={closeMobileMenu} onOpenMenu={openMobileMenu} />
      <main style={{ flex: 1 }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path={'/hakkimizda'} element={<About />} />
          <Route path="/sirketlerimiz" element={<Companies />} />
          <Route path="/ngaming-hayat" element={<Career />} />
          <Route path="/iletisim" element={<Contact />} />
          <Route path="/kisisel-verileri-koruma" element={<KvkPolicy />} />
          <Route path="/cerez-politikasi" element={<CookiePolicy />} />

          <Route path="/en/about" element={<About />} />
          <Route path="/our-companies" element={<Companies />} />
          <Route path="/career" element={<Career />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/personel-data-protection-gdpr" element={<KvkPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />

          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <CookiesPopup />
    </div>
  );
};

const AppWrapper = () => {
  return (
    <HelmetProvider>
      <HashRouter>
        <App />
      </HashRouter>
    </HelmetProvider>
  );
};

export default AppWrapper;
